import * as constants from '../constants';
import { LoadMassInquiryVenues } from '../actions/mass-inquiry';
import { MassInquiryPageData } from '../types';

const getDefaultState = () => [];

export function massInquiryVenuesData(state: MassInquiryPageData = getDefaultState(), action: LoadMassInquiryVenues) {
    switch (action.type) {
        case constants.LOAD_MASS_INQUIRY_VENUES:
            return action.payload;
        default:
            return state;
    }
}

export default massInquiryVenuesData;
